export const PLUGIN_ADDED = 'pluginAdded'
export const PLUGIN_REMOVED = 'pluginRemoved'
export const CREATOR_ADDED = 'creatorAdded'
export const CREATOR_REMOVED = 'creatorRemoved'
export const CREATOR_CHANGED = 'creatorChanged'
export const DEFAULT = 'default'
